import { NgModule } from '@angular/core';
import { BuyflowRequestFormFieldDialogComponent } from './buyflow-request-form-field-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { AppMaterialModule } from '../../appMaterial/app-material.module';
import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@NgModule({
  declarations: [BuyflowRequestFormFieldDialogComponent],
  imports: [
    CommonModule,
    AppMaterialModule,
    FormsModule,
    MatButtonModule,
    MatSelectModule,
    MatDatepickerModule,
  ],
  exports: [BuyflowRequestFormFieldDialogComponent],
  providers: [{ provide: MAT_BOTTOM_SHEET_DATA, useValue: {} }],
})
export class BuyflowRequestFormFieldDialogModule {}
